import * as getters from './getters.js';

export function setNewColvisButton(container) {
    const btn = container.querySelector('.buttons-colvis');

    if (btn) {
        btn.classList.remove('btn-secondary');
        btn.classList.add('btn-link');
        btn.style.width = '50px';
        btn.innerHTML = '<i class="fa fa-columns"></i>';
        $(btn).detach();
        const colvisContainer = $(container).find('.table-datatable-toolbar .table-datatable-colvis-place');
        colvisContainer.addClass('colvis-added').prepend(btn);
    }
}

export function setProperlyPage(container, instance) {
    instance.on('page.dt', e => {
        $(container).find('.pagination-element [name="start"]').val(instance.page.info().page + 1);
    });
};

export function setProperlySearchMobileButton(container) {
    const btn = container.querySelector('.mobile-search-button');

    if (btn) {
        btn.classList.add('mobile-search-button-added');
        $(btn).detach();
        $(container).find('.new-place-colvis').after(btn);
    }
}
